<template>
    <div class="power-bi">
        <div class="my-3 text-center d-block d-md-none">
            <button
                @click.prevent="eventBusListeren('export')"
                class="power-bi-btn-action solid"
            >
                Export
            </button>
            <button
                @click.prevent="eventBusListeren('import')"
                class="power-bi-btn-action"
            >
                Import
            </button>
        </div>
        <div class="nav-block">
            <div
                class="nav-block-cat"
                v-for="(item, $index) in menuItems.categoriesHeader"
                :key="item.value"
                :class="[
                    { line: $index != 0 },
                    { 'gap-col-3': item.items.length == 6 },
                    { 'gap-col-2': item.items.length < 5 },
                ]"
            >
                <div
                    v-for="cat in item.items"
                    :key="cat.icon"
                    class="nav-block-items"
                >
                    <CustomTooltip :content="cat.title">
                        <a
                            @click.prevent="currentItem = cat.name"
                            href="#"
                            :class="{ active: currentItem == cat.name }"
                        >
                            <CustomIcon :name="cat.icon" />
                        </a>
                    </CustomTooltip>
                </div>
            </div>
        </div>

        <div class="mt-4">
            <div class="row">
                <div class="col-12 col-md-3">
                    <div class="power-bi-current">
                        {{ currentItemName }}
                    </div>
                    <div class="power-bi-preview">
                        <img
                            v-if="!!currentItemImage"
                            :src="`/images/icons/${currentItemImage}`"
                            alt=""
                        />
                    </div>
                </div>
                <div class="col-12 col-md-9">
                    <div class="" id="accordionExample" ref="accordionExample">
                        <CollapsItem
                            v-for="(data, key, index) in themeConfig[
                                currentItem
                            ].items"
                            :key="index"
                            :key-item="key"
                            :data="data"
                            :index="index"
                            :current-category="currentItem"
                            @reset="resetDefaultValue"
                        />
                    </div>
                </div>
            </div>
        </div>
        <!-- <v-dialog>fghhgdsdfsdfsdfh</v-dialog> -->
        <modal
            name="power"
            :adaptive="true"
            :height="250"
            class="power-bi-modal"
        >
            <h2 class="window-header">Theme file name</h2>
            <div class="window-body" v-if="!createdTheme">
                <div class="form-group">
                    <label for="fileName"
                        >Use the suggested or enter your own file name</label
                    >
                    <input
                        type="text"
                        v-model="fileName"
                        id="fileName"
                        class="form-control"
                    />
                </div>
                <div class="text-center">
                    <button
                        @click.prevent="$modal.hide('power')"
                        class="btn btn-outline-primary"
                    >
                        Cancel
                    </button>
                    <button
                        @click.prevent="exportTheme"
                        class="btn btn-primary"
                    >
                        Download
                    </button>
                    <button
                        @click.prevent="saveThemeInDocuments"
                        class="btn btn-outline-primary"
                    >
                        Save
                    </button>
                </div>
            </div>
            <div class="window-body" v-else>
                <h4 class="text-center text-primary">Please wait ...</h4>
            </div>
        </modal>
        <modal
            name="import-theme"
            :adaptive="true"
            :height="200"
            class="power-bi-modal"
        >
            <h2 class="window-header">Import theme file</h2>
            <div class="window-body" v-if="!importThemeFileLoader">
                <form @submit.prevent="importTheme">
                    <div class="upload-field my-4">
                        <div class="" v-if="importThemeFileName">
                            Theme name:
                            <strong>{{ importThemeFileName }}</strong> [<a
                                href="#delete"
                                @click.prevent="importThemeFile = {}"
                                class="text-muted text-danger"
                                >delete</a
                            >]
                        </div>
                        <input
                            v-else
                            type="file"
                            name="theme"
                            ref="theme"
                            class="form-control-file"
                            accept="application/json"
                            @change="handelUploadThemeFile"
                        />
                    </div>
                    <div class="text-center">
                        <button
                            @click.prevent="$modal.hide('import-theme')"
                            class="btn btn-outline-primary"
                        >
                            Cancel
                        </button>
                        <button type="submit" class="btn btn-primary">
                            Upload
                        </button>
                    </div>
                </form>
            </div>
            <div class="window-body" v-else>
                <h4 class="text-center text-primary">Please wait ...</h4>
            </div>
        </modal>
        <modal
            name="save-document"
            :adaptive="true"
            :height="200"
            class="power-bi-modal"
        >
            <h2 class="window-header">Power BI theme saved in Documents</h2>
            <div class="window-body" v-if="!importThemeFileLoader">
                <form>
                    <div class="text-center">
                        <button
                            @click.prevent="$modal.hide('save-document')"
                            class="btn btn-outline-primary"
                        >
                            Cancel
                        </button>
                        <button
                            @click.prevent="
                                newDocument = true;
                                exportTheme();
                            "
                            class="btn btn-primary"
                        >
                            Download
                        </button>
                    </div>
                </form>
            </div>
            <div class="window-body" v-else>
                <h4 class="text-center text-primary">Please wait ...</h4>
            </div>
        </modal>
        <UpScrollPosition />
        <doc-name v-if="settingTitle" :doc-data="documentData"></doc-name>
    </div>
</template>

<script>
import { cardName, visualStyles, items, enumerations } from "./config/data.js";
import { EventBus } from "@/util/eventbus";
import themeParts from "./assets/themeParts";
import themeProperties from "./config/themeProperties.js";
import themeConfig from "./config/themeConfig.js";
import themeConfigGlobal from "./config/themeConfigGlobal.js";
import vmodal from "vue-js-modal";
import { mapGetters } from "vuex";
import CustomIcon from "./components/CustomIcon.vue";
import CollapsItem from "./components/CollapsItem.vue";
import exportFromJSON from "export-from-json";
import UpScrollPosition from "./components/UpScrollPosition.vue";
import CustomTooltip from "./components/CustomTooltip.vue";
import { isEqual } from "lodash";
import DocName from "../DocName";
import DocumentHttpService from "../../services/DocumentHttpService";
import { serialize } from "object-to-formdata";
import ApiService from "../../api/api.service";
// import fs from 'fs';

function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

export default {
    name: "Theme",
    data: function () {
        return {
            fileName: "PowerBI",
            fileDescription: "",
            settingTitle: "",
            saveDocFlag: false,
            currentCategory: "general",
            visualStyles: visualStyles,
            cardName: cardName,
            items: items,
            options: enumerations,
            currentItem: "global",
            themeParts: themeParts,
            themeProperties: themeProperties,
            themeConfig: { ...themeConfigGlobal, ...themeConfig },
            // themeConfig: themeConfig,
            // themeConfigDefault: themeConfigDefault,
            themeConfigDefault: _.cloneDeep({
                ...themeConfigGlobal,
                ...themeConfig,
            }),
            theme: {},
            importThemeFile: {},
            importThemeFileLoader: false,
            isGlobalChanges: false,
            createdTheme: false,
            generalCategories: {
                general: "General",
                "cart-line": "Column Cart",
                cart: "Line Cart",
                "cart-custom": "Other Cart",
                map: "Map",
                kpi: "KTI/Table",
                qa: "Customize",
                settings: "Settings",
            },
            docService: null,
            documentData: {
                name: "",
                description: "",
                shared: false,
                entity_name: "PowerBITheme",
                entity_data: {},
                file: null,
            },
            newDocument: false,
        };
    },
    computed: {
        ...mapGetters({
            isLoggedIn: "isLoggedIn",
            getUser: "getUser",
        }),
        menuItems() {
            function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            }
            const sidebar = Object.values(this.themeConfig)
                .map((el) => el.config.navSection)
                .filter(onlyUnique);
            const categories = [];
            Object.keys(this.generalCategories).forEach((gcat) => {
                const c = Object.entries(this.themeConfig)
                    .filter((el) => el[1].config.navSection == gcat)
                    .map((cat) => ({
                        name: cat[0],
                        ...cat[1].config,
                    }));
                categories.push({
                    value: gcat,
                    label: this.generalCategories[gcat],
                    items: c,
                });
            });
            return {
                sidebar: sidebar,
                categories: Object.entries(this.themeConfig)
                    .filter(
                        ([cat, val]) =>
                            val.config.navSection === this.currentCategory
                    )
                    .map((c) => ({
                        value: c[0],
                        label: c[1].config.title,
                    })),
                categoriesHeader: categories,
            };
        },
        currentItemImage() {
            const img = Object.entries(this.themeConfig).find(
                ([cat, val]) => cat === this.currentItem
            );
            return img[1]?.config?.image;
        },
        currentItemName() {
            const img = Object.entries(this.themeConfig).find(
                ([cat, val]) => cat === this.currentItem
            );
            return img[1]?.config?.title;
        },
        importThemeFileName() {
            if (typeof this.importThemeFile == "string") {
                const j = JSON.parse(this.importThemeFile) || {};
                return j.name ? j.name : false;
            }
            return false;
        },
    },
    watch: {
        currentCategory(newVal) {
            this.currentItem = this.menuItems.categories[0]?.value;
        },
        themeConfig: {
            handler: function (val, oldVal) {
                var vm = this;

                var changed = Object.entries(val).forEach(function ([p, idx]) {
                    if (
                        !isEqual(
                            idx.items,
                            vm.$data.themeConfigDefault[p].items
                        )
                    ) {
                        vm.$data.themeConfig[p].config.changed = true;
                        if (
                            p == "global" ||
                            p == "page" ||
                            p == "globalStyles"
                        ) {
                            vm.$data.isGlobalChanges = true;
                        }
                    }
                });
            },
            deep: true,
        },
    },

    methods: {
        resetDefaultValue(obj) {
            this.themeConfig[obj.currentCategory].items[obj.keyItem][obj.item] =
                this.themeConfigDefault[obj.currentCategory].items[obj.keyItem][
                    obj.item
                ];
        },
        toName(name, key) {
            if (!name) return null;
            return typeof name == "object" ? name[key] : name;
        },
        eventBusListeren(t) {
            switch (t) {
                case "export":
                    this.$modal.show("power");
                    break;
                case "import":
                    this.$modal.show("import-theme");
                    // this.importTheme();
                    break;
                default:
                    break;
            }
        },
        async handelUploadThemeFile($event) {
            this.importThemeFileLoader = true;
            this.importThemeFile = await new Promise((resolve, reject) => {
                var fr = new FileReader();

                fr.onload = function (e) {
                    var result = e.target.result;
                    // var formatted = JSON.stringify(result, null, 2);
                    resolve(result);
                };

                fr.readAsText($event.target.files.item(0));
            });
            this.importThemeFileLoader = false;
        },
        importTheme($event) {
            this.makeThemeConfigFromJson();
            this.$modal.hide("import-theme");
        },
        saveDoc(data) {
            // if (!this.$route.query?.id) {
            this.settingTitle = false;

            this.documentData.name = data.name;
            this.documentData.description = data.description;
            this.documentData.shared = data.shared;
            this.documentData.team_shared = data.team_shared;
            // this.exportTheme();
            // }
            this.exportTheme();
        },
        saveThemeInDocuments() {
            // check login
            if (!this.isLoggedIn) {
                this.documentData["config"] = this.themeConfig;
                localStorage.setItem(
                    "temp_app_data",
                    JSON.stringify(this.documentData)
                );
                this.$router.push({ path: "/login" });
            }

            this.$modal.hide("power");
            // if (!this.$route.query?.id) {
            this.saveDocFlag = true;
            this.settingTitle = true;
            // } else {
            //   this.saveDoc();
            // }
        },
        async updateThemeInDocuments(id) {
            try {
                const { data } = await this.docService.get(id);

                this.documentData = data.doc;
                // this.documentData.name = data.doc.name;
                // this.documentData.description = data.doc.description;
                // this.documentData.shared = data.doc.shared;
                // this.documentData.team_shared = data.doc.team_shared;

                this.importThemeFile = data.file;
                this.makeThemeConfigFromJson();
            } catch (error) {
                console.log("error :>> ", error);
            }
        },
        makeThemeConfigFromJson() {
            const { visualStyles, ...global } = JSON.parse(
                this.importThemeFile
            );

            function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            }

            const setFormat = (type, val) => {
                if (
                    /color|Color|Background|background|foreground|fill|Fill/.test(
                        type
                    )
                ) {
                    return val?.solid?.color;
                } else {
                    return val;
                }
            };
            const createThemeColors = (arr) => {
                const tmpObj = {};
                arr.forEach((el, $index) => {
                    tmpObj[`color-${$index + 1}`] = el;
                });
                return tmpObj;
            };
            function capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
            const createTextClasses = (textClasses) => {
                const classesValue = {};
                Object.entries(textClasses).forEach(([key, val]) => {
                    classesValue[`textClasses${capitalizeFirstLetter(key)}`] = {
                        fontFace: val.fontFace,
                        fontSize: val.fontSize,
                        color: val.color,
                    };
                });
                return classesValue;
            };

            const makeGlobalProps = (globalProperties) => {
                if (!globalProperties?.dataColors) {
                    return {
                        ...this.themeConfig.global.items,
                        name: {
                            name: globalProperties.name,
                        },
                    };
                } else {
                    return {
                        name: {
                            name: globalProperties.name,
                        },
                        themeColors: createThemeColors(
                            globalProperties.dataColors
                        ),
                        statusColors: {
                            good: globalProperties.good,
                            neutral: globalProperties.neutral,
                            bad: globalProperties.bad,
                        },
                        variousGradient: {
                            maximum: globalProperties.maximum,
                            center: globalProperties.center,
                            minimum: globalProperties.minimum,
                        },
                        advanced: {
                            foreground: globalProperties.foreground,
                            foregroundNeutralSecondary:
                                globalProperties.foregroundNeutralSecondary,
                            backgroundLight: globalProperties.backgroundLight,
                            foregroundNeutralTertiary:
                                globalProperties.foregroundNeutralTertiary,
                            background: globalProperties.background,
                            backgroundNeutral:
                                globalProperties.backgroundNeutral,
                        },
                        ...createTextClasses(globalProperties.textClasses),
                    };
                }
            };

            const changeOptions = (o) => {
                const mutable = Object.entries(o).map(([l, r]) => {
                    return [
                        [l],
                        Object.fromEntries(
                            Object.entries(r[0]).map(([key, val]) => {
                                return [[key], setFormat(key, val)];
                            })
                        ),
                    ];
                });
                return Object.fromEntries(mutable);
            };
            const p = Object.entries(visualStyles).map(([l, r]) => {
                return [[l], changeOptions(r["*"])];
            });

            const allProps = {
                ...Object.fromEntries(p),
                global: makeGlobalProps(global),
            };

            Object.entries(allProps).forEach(([key, val]) => {
                let CURRENT_KEY = key;
                if (key == "*") {
                    CURRENT_KEY = "globalStyles";
                }
                this.themeConfig[CURRENT_KEY].items = val;
            });

            // this.createNewConfigFile(this.themeConfig);

            // const f = Object.values(this.themeConfig)
            //     .map((el) => {
            //         return Object.values(el.items)
            //             .map((k) => Object.keys(k))
            //             .flat()
            //             .filter(onlyUnique);
            //     })
            //     .flat()
            //     .filter(onlyUnique);
            // const g = Object.keys(this.themeProperties);
            // console.log(
            //     "f :>> ",
            //     f.filter((el) => !g.includes(el))
            // );
        },
        createNewConfigFile(ob) {
            const section = Object.values(ob)
                .map((el) => el.config.navSection)
                .filter(onlyUnique);
            section.push("global");
            const newConf = {};
            for (const iterator of section) {
                newConf[iterator] = {};
            }
            const { global, globalStyles, page, ...rest } = ob;
            for (const iterator of section) {
                for (const sec of Object.entries(rest)) {
                    if (sec[1].config.navSection == iterator) {
                        const name = sec[0];
                        newConf[iterator][name] = sec[1];
                    }
                }
            }
            console.log("section :>> ", newConf);
        },
        async exportTheme() {
            this.createdTheme = true;
            let data = {
                // visualStyles: t,
            };
            const t = {};

            const sortObject = (obj, key) => {
                return Object.fromEntries(
                    Object.entries(obj).sort(function (x, y) {
                        return x[0] == key ? -1 : y[0] == key ? 1 : 0;
                    })
                );
            };

            const mutationToArray = (arr) => {
                const t = {};

                Object.entries(arr).forEach((el) => {
                    if (/filterCard/.test(el[0])) {
                        t[el[0]] = el[1];
                    } else {
                        t[el[0]] = [el[1]];
                    }
                });
                return t;
            };

            const setFormat = (type, val) => {
                if (
                    /color|Color|Background|background|foreground|fill|Fill/.test(
                        type
                    )
                ) {
                    return { solid: { color: val } };
                } else {
                    return val;
                }
            };

            const isChanges = (key, obj) => {
                const changedObj = {};
                Object.entries(this.themeConfigDefault[key].items).forEach(
                    ([a, b]) => {
                        const changed = {};
                        const changedTemp = {};
                        let flag = false;

                        Object.entries(b).forEach(([c, d]) => {
                            // if (obj[a][c] != d) {
                            if (/filterCard/.test(a)) {
                                changedTemp["$id"] = a.replace(
                                    "filterCard",
                                    ""
                                );
                                changedTemp[c] = setFormat(c, obj[a][c]);
                                flag = true;
                            } else {
                                changed[c] =
                                    key == "global"
                                        ? obj[a][c]
                                        : setFormat(c, obj[a][c]);
                            }

                            // }
                        });

                        // if (flag) {
                        if (/filterCard/.test(a)) {
                            if (
                                typeof changedObj["filterCard"] == "undefined"
                            ) {
                                changedObj["filterCard"] = [];
                            }
                            changedObj["filterCard"].push(changedTemp);
                        } else {
                            changedObj[a] = changed;
                        }
                        // }
                    }
                );
                return changedObj;
            };

            const setGlobalConfig = (global) => {
                const gConfig = {
                    textClasses: {
                        label: {},
                        callout: {},
                        header: {},
                        title: {},
                    },
                    dataColors: [],
                };

                Object.entries(global.items).forEach(([name, val]) => {
                    Object.entries(val).forEach(([p, v]) => {
                        if (/textClasses/.test(name)) {
                            gConfig.textClasses[
                                name.replace("textClasses", "").toLowerCase()
                            ][p] = v;
                        } else if (name == "themeColors") {
                            gConfig["dataColors"].push(v);
                        } else {
                            gConfig[p] = v;
                        }
                    });
                });
                data = {
                    ...gConfig,
                };
                return data;
            };

            const setVisualStyles = (visualStylesFilter) => {
                const ds = Object.entries(visualStylesFilter).map((el) => {
                    const validItem = isChanges(el[0], el[1].items);
                    if (Object.keys(validItem).length) {
                        const name = el[0] == "globalStyles" ? "*" : el[0];
                        return {
                            [name]: {
                                "*": mutationToArray(validItem),
                            },
                        };
                    }
                });

                ds.filter((el) => typeof el != "undefined").forEach((el) => {
                    t[Object.keys(el)] = el[Object.keys(el)];
                });
                data = {
                    ...data,
                    name: this.themeConfig.global.items.name.name,
                    visualStyles: t,
                };
            };

            if (this.isGlobalChanges) {
                const { global, page, globalStyles, ...visualStyles } =
                    this.themeConfig;
                setGlobalConfig(global, data);
                const visualStylesFilter = Object.fromEntries(
                    Object.entries(visualStyles).filter(
                        ([key, val]) => val.config.changed
                    )
                );
                setVisualStyles({ page, globalStyles, ...visualStylesFilter });
            } else {
                const { global, ...visualStyles } = this.themeConfig;

                const visualStylesFilter = Object.fromEntries(
                    Object.entries(visualStyles).filter(
                        ([key, val]) => val.config.changed
                    )
                );
                setVisualStyles(visualStylesFilter);
            }
            const exportType = exportFromJSON.types.json;

            this.$modal.hide("power");
            this.createdTheme = false;
            this.downloadObjectAsJson(sortObject(data, "name"), this.fileName);

            // exportFromJSON({
            //   data: sortObject(data, "name"),
            //   fileName: this.fileName,
            //   exportType,
            // });
        },
        async storeTheme(file) {
            const options = {
                booleansAsIntegers: true,
                noFilesWithArrayNotation: true,
            };
            try {
                this.documentData.file = file;
                const { data } = await this.docService.store(
                    serialize(this.documentData, options)
                );
                this.documentData = data.doc;

                this.$router.push({ query: { id: data.doc.document_id } });
                this.newDocument = true;
                this.$modal.show("save-document");
            } catch (error) {
                console.log("error :>> ", error);
            }
        },
        async updateTheme(file) {
            const options = {
                booleansAsIntegers: true,
                noFilesWithArrayNotation: true,
            };
            try {
                this.documentData.file = file;
                ApiService.setHeader();
                const { data } = await ApiService.post(
                    "/api/document/" + this.$route.query?.id + "?_method=PUT",
                    serialize(this.documentData, options)
                );
                // const { data } = await this.docService.store(
                //   serialize(this.documentData, options)
                // );
                console.log("data :>> ", data);
            } catch (error) {
                console.log("error :>> ", error);
            }
        },
        async downloadObjectAsJson(exportObj, exportName) {
            var dataStr =
                "data:text/json;charset=utf-8," +
                encodeURIComponent(JSON.stringify(exportObj));
            var json = JSON.stringify(exportObj);
            var blob = new Blob([json], { type: "application/json" });
            if (this.$route.query?.id && !this.newDocument) {
                this.updateTheme(blob);
                return;
            }
            if (this.saveDocFlag && !this.newDocument) {
                await this.storeTheme(blob);
            } else {
                var downloadAnchorNode = document.createElement("a");
                downloadAnchorNode.setAttribute("href", dataStr);
                downloadAnchorNode.setAttribute(
                    "download",
                    exportName + ".json"
                );
                document.body.appendChild(downloadAnchorNode); // required for firefox
                downloadAnchorNode.click();
                downloadAnchorNode.remove();
                this.$modal.hide("save-document");
                this.newDocument = false;
            }
        },
    },
    async mounted() {
        EventBus.$on("powerbi", this.eventBusListeren);
        this.docService = new DocumentHttpService();
        if (this.$route.query?.id) {
            await this.updateThemeInDocuments(this.$route.query?.id);
        }

        if (localStorage.getItem("temp_app_data")) {
            const { config, ...doc } = JSON.parse(
                localStorage.getItem("temp_app_data")
            );
            this.documentData = doc;
            this.themeConfig = config;
            localStorage.removeItem("temp_app_data");
        }
        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }
        // const f = Object.values(this.themeConfig)
        //   .map((el) => {
        //     return Object.values(el.items)
        //       .map((k) => Object.keys(k))
        //       .flat()
        //       .filter(onlyUnique);
        //   })
        //   .flat()
        //   .filter(onlyUnique);
        // const g = Object.keys(this.themeProperties);
        // console.log("f :>> ", f.filter( el => !g.includes(el)), );
    },
    components: {
        CustomIcon,
        CollapsItem,
        vmodal,
        UpScrollPosition,
        CustomTooltip,
        DocName,
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
</style>
